import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { internalSelectionMenuBodyInjectionKey as a } from "../../_internal/select-menu/src/interface.js";
import { drawerBodyInjectionKey as m } from "../../drawer/src/interface.js";
import { modalBodyInjectionKey as v } from "../../modal/src/interface.js";
import { popoverBodyInjectionKey as s } from "../../popover/src/interface.js";
import { inject as i, onMounted as p, onBeforeUnmount as y } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { on as j, off as B } from "../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import b from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { ref as _ } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const d = "__disabled__";
function f(c) {
  const o = i(v, null), l = i(m, null), t = i(s, null), r = i(a, null), u = _();
  if (typeof document != "undefined") {
    u.value = document.fullscreenElement;
    const n = () => {
      u.value = document.fullscreenElement;
    };
    p(() => {
      j("fullscreenchange", document, n);
    }), y(() => {
      B("fullscreenchange", document, n);
    });
  }
  return b(() => {
    var n;
    const {
      to: e
    } = c;
    return e !== void 0 ? e === !1 ? d : e === !0 ? u.value || "body" : e : o != null && o.value ? (n = o.value.$el) !== null && n !== void 0 ? n : o.value : l != null && l.value ? l.value : t != null && t.value ? t.value : r != null && r.value ? r.value : e != null ? e : u.value || "body";
  });
}
f.tdkey = d;
f.propTo = {
  type: [String, Object, Boolean],
  default: void 0
};
export {
  f as useAdjustedTo
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/composable/use-adjusted-to.js
// module id = 151
// module chunks = 67